<form [formGroup]="createForm" (ngSubmit)="onCreateSubmit()">
  <div class="fwc-container">
    <div class="fwc-row fwc-row-bm">
      <div class="fwc-input">
        <div class="fwc-flex">
          <label for="Email" class="label-w-tooltip">Email</label>
          <fwc-tooltip icon term="email" message="A valid email must be used."
          class="label-tooltip"></fwc-tooltip>
        </div>
        <input formControlName="email" name="Email" id="Email" type="text"
          attr.aria-invalid="{{submitted && form.email.errors ? true : false}}"
          (keyup)="validateFields()" maxlength="255" required/>
        @if (submitted && form.email.errors) {
          <span role="alert" class="fwc-inline-icon fwc-icon-delete"
          id="email_error">Please enter a valid Email</span>
        }
        @if (emailValidateError && submitted && !form.email.hasError('required')) {
          <div >
            <span role="alert" class="fwc-inline-icon fwc-icon-delete">Please enter a valid email address</span>
          </div>
        }

      </div>
    </div>
    <div class="fwc-row fwc-row-bm">
      <div class="fwc-input">
        <label for="ConfirmEmail">Confirm Email</label>
        <input name="ConfirmEmail" formControlName="confirmEmail" id="ConfirmEmail" type="text"
          attr.aria-invalid="{{submitted && form.confirmEmail.errors ? true : false}}"
          (keyup)="validateFields()"  maxlength="255"
          required/>

        @if (submitted && form.confirmEmail.errors && form.confirmEmail.value.length==0) {
          <span role="alert" class="fwc-inline-icon fwc-icon-delete"
          id="confirmEmail_error">Please confirm email</span>
        }
        @if (emailMatchError && submitted && !form.confirmEmail.hasError('required')) {
          <div>
            <span role="alert" class="fwc-inline-icon fwc-icon-delete">The emails must match. Please reenter your email address</span>
          </div>
        }
      </div>
    </div>
    <div class="fwc-row fwc-row-bm fwc-flex-column">
      <div class="fwc-input">
        <label for="Password">Create Password</label>
        <div class="sae-masked-input">
          <input name="Password" formControlName="usrSecret" id="Password" type="password"
            maxlength="20"
            [attr.type]="createMask ? 'password':'text'"
            attr.aria-invalid="{{submitted && form.usrSecret.errors ? true : false}}"
            (keydown) = "onKey($event)"
            (keyup)="checkPasswordRules();validateFields()"
            required/>
          <span class="sae-icon" [ngClass]="{'sae-icon-blind': createMask, 'sae-icon-eye': !createMask}" type="button" (click)="createMask = !createMask"></span>
        </div>
        @if (submitted && form.usrSecret.errors) {
          <span role="alert" class="fwc-inline-icon fwc-icon-delete"
          id="password_error">Please enter a valid password</span>
        }
        @if (passwordValidateError && submitted && !form.usrSecret.hasError('required')) {
          <div>
            <span role="alert" class="fwc-inline-icon fwc-icon-delete">Invalid password</span>
          </div>
        }
      </div>
      @if (showPasswordRules) {
        <div class="sae-password-rules">
          <ul>
            <li [ngClass]="{'rule-met' : ruleLowerMet, 'error-state' : passwordValidateError && submitted && !ruleLowerMet}">One lowercase character</li>
            <li [ngClass]="{'rule-met' : rule8characterMet, 'error-state' : passwordValidateError && submitted && !rule8characterMet}">12 characters minimum</li>
            <li [ngClass]="{'rule-met' : ruleNumberMet, 'error-state' : passwordValidateError && submitted && !ruleNumberMet}">One number</li>
            <li [ngClass]="{'rule-met' : ruleSpecialMet, 'error-state' : passwordValidateError && submitted && !ruleSpecialMet}">One special character  $ ! &#64; * ? |</li>
            <li [ngClass]="{'rule-met' : ruleUpperCharMet, 'error-state' : passwordValidateError && submitted && !ruleUpperCharMet}">One uppercase character</li>
          </ul>
        </div>
      }
    </div>
    <div class="fwc-row fwc-row-bm">
      <div class="fwc-input">
        <label for="RetypePassword">Retype Password</label>
        <div class="sae-masked-input">
          <input name="RetypePassword" formControlName="retypePassword" id="RetypePassword" type="password"
            maxlength="20"
            [attr.type]="retypeMask ? 'password':'text'"
            (keydown.space)="$event.preventDefault()"
            attr.aria-invalid="{{submitted && form.retypePassword.errors ? true : false}}" (keyup)="validateFields()" required/>
          <span class="sae-icon" [ngClass]="{'sae-icon-blind': retypeMask, 'sae-icon-eye': !retypeMask}" type="button" (click)="retypeMask = !retypeMask"></span>
        </div>
        @if (submitted && form.retypePassword.errors) {
          <span role="alert" class="fwc-inline-icon fwc-icon-delete"
          id="retypePassword_error">Please retype password</span>
        }
        @if (passwordMatchError && submitted && !form.retypePassword.hasError('required')) {
          <div>
            <span role="alert" class="fwc-inline-icon fwc-icon-delete">The passwords do not match. Please re-enter your new password.</span>
          </div>
        }

      </div>
    </div>

    <div class="fwc-row fwc-row-bm">
      <div class="fwc-input">
        <div class="fwc-flex">
          <label for="StudentId" class="label-w-tooltip">Student ID #</label>
          <fwc-tooltip icon term="Student ID"
            message="A school issued Student ID # should be used here. If Student have not been assigned a school issued ID# then they have to use valid Passport ID#.."
          class="label-tooltip"></fwc-tooltip>
        </div>
        <input name="StudentId" formControlName="studentId" id="StudentId" type="text"
          maxlength="25" [pattern]=studentIDPatteren
          attr.aria-invalid="{{submitted && form.studentId.errors ? true : false}}"  (keyup)="validateFields()" required/>
        @if (submitted && form.studentId.errors) {
          <span role="alert" class="fwc-inline-icon fwc-icon-delete"
          id="studentId_error">Please enter a valid student ID</span>
        }
      </div>
    </div>
    <div class="fwc-row fwc-row-bm fwc-flex-column">
      <fwc-date-picker
        id="{{'dob-input'}}"
        attr.input-label="{{'Date of Birth'}}"
        [invalid]="form.dob.errors && submitted"
        (fwc-date-picker-blur)="blurEvent($event)"
      (fwc-date-picker-selected)="updateDob($event)"></fwc-date-picker>
      <div class="fwc-input">
        <input type="hidden" formControlName="dob" id="DatePickerOneValue" name="datepicker-value-one" (keyup)="validateFields()"/>
        @if (form.dob.errors && submitted) {
          <span role="alert" class="fwc-inline-icon fwc-icon-delete" id="DatePickerOneError">Please enter a valid date of birth</span>
        }
        @if (dobError && submitted && !form.dob.hasError('required')) {
          <div>
            <span role="alert" class="fwc-inline-icon fwc-icon-delete">Student must be 14 years of age or older to create an account</span>
          </div>
        }
      </div>
    </div>
    <div class="fwc-row fwc-row-bm">
      <button class="fwc-btn fwc-btn-primary">{{content.button}}</button>
    </div>
  </div>
</form>
@if (displaySpinner) {
  <div class="ant-ui-widget-overlay"></div>
  <div class="ant-ajax-loader">
    <fwc-preloader></fwc-preloader>
  </div>
}
